<template>
  <div class="d-flex justify-content-center">
    <section
      class="news-section"
      style="padding: 0; max-width: 1200px !important"
    >
      <div class="container pb-4">
        <div class="row">
          <div class="col-8">
            <h2 style="font-size: 1.5rem; font-weight: 500; color: #2c3e50">
              Цаг үеийн мэдээ
            </h2>

            <div class="row g-4">
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-4"
                v-for="(t, i) in tasks"
                :key="i"
              >
                <div class="news-card">
                  <a
                    v-if="
                      $store.state.app.activeGroup.publicPage.readUrl !==
                        undefined &&
                        $store.state.app.activeGroup.publicPage.readUrl !== ''
                    "
                    target="_blank"
                    :href="
                      `${$store.state.app.activeGroup.publicPage.readUrl}/c/${$store.state.app.contentPageId}?cid=${t.id}`
                    "
                    class="news-link"
                  >
                    <div class="news-image-container">
                      <img
                        :src="`${t.defaultAttachmentUrl}?w=400&h=250&mode=crop`"
                        class="news-image"
                        :alt="t.task"
                      />
                    </div>
                    <div class="news-content">
                      <h3 class="news-title">{{ t.task }}</h3>
                      <div class="news-meta">
                        <span class="news-date">
                          {{ t.createdDate | moment("YYYY.MM.DD") }}
                        </span>
                        <span class="news-category">ДЭЛГЭРЭНГҮЙ</span>
                      </div>
                    </div>
                  </a>
                  <router-link
                    v-else
                    :to="{
                      name: $store.state.app.activeGroup.publicPage.route,
                      params: {
                        id: $store.state.app.contentPageId,
                        cid: t.id
                      }
                    }"
                    class="news-link"
                  >
                    <div class="news-image-container">
                      <img
                        :src="`${t.defaultAttachmentUrl}?w=400&h=250&mode=crop`"
                        class="news-image"
                        :alt="t.task"
                      />
                    </div>
                    <div class="news-content">
                      <h3 class="news-title">{{ t.task }}</h3>
                      <div class="news-meta">
                        <span class="news-date">
                          {{ t.d1 | moment("YYYY.MM.DD") }}
                        </span>
                        <span class="news-category">ДЭЛГЭРЭНГҮЙ</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="row" v-if="comp.id === 6490915">
              <div class="col-12">
                <div class="text-center">
                  <router-link
                    :to="{
                      name: $store.state.app.activeGroup.publicPage.route,
                      params: { id: 6330214, cid: 0 }
                    }"
                    class="btn btn-primary"
                  >
                    Бусад мэдээ үзэх
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <h2 style="font-size: 1.5rem; font-weight: 500; color: #2c3e50; margin-bottom: 32px;">
              Сургалтын зар
            </h2>

            <div class="training-list mt-4">
              <div class="training-item mt-0.5" v-for="(t, i) in tasks2" :key="i">
                <router-link
                  :to="{
                    name: $store.state.app.activeGroup.publicPage.route,
                    params: {
                      id: $store.state.app.contentPageId,
                      cid: t.id
                    }
                  }"
                  class="media-link"
                >
                  <div class="media-image">
                    <img
                      :src="`${t.defaultAttachmentUrl}?w=150&h=150&mode=crop`"
                      :alt="t.task"
                    />
                  </div>
                  <div class="media-content">
                    <h3 class="media-title">{{ t.task }}</h3>
                    <p class="media-description" v-if="t.description">
                      {{ t.description }}
                    </p>
                    <div class="media-footer">
                      <span class="media-date">
                        <i class="mdi mdi-calendar"></i>
                        {{ t.d1 | moment("YYYY.MM.DD") }}
                      </span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <!-- {{ comp }} -->

            <div class="row" style="margin-top: 10px;" v-if="comp.id === 6490915">
              <div class="col-12">
                <div class="text-center">
                  <router-link
                    :to="{
                      name: $store.state.app.activeGroup.publicPage.route,
                      params: { id: 6491392, cid: 0 }
                    }"
                    class="btn btn-primary"
                  >
                    Бусад сургалтын зар
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      tasks2: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
    this.loadTasks2(this.comp.locTypeId2);
  },
  methods: {
    loadTasks(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    },
    loadTasks2(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks2 = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style scoped>
.news-section {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.news-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  position: relative;
}

.news-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.news-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.news-link:hover {
  text-decoration: none;
  color: inherit;
}

.news-image-container {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-card:hover .news-image {
  transform: scale(1.05);
}

.news-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
  min-height: 140px;
}

.news-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #2c3e50;
  margin: 0 0 15px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  flex-grow: 1;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 10px;
}

.news-date {
  font-size: 13px;
  color: #6c757d;
  font-weight: 400;
}

.news-category {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive adjustments */
@media (max-width: 1199.98px) {
  .news-card {
    margin-bottom: 20px;
  }
}

@media (max-width: 767.98px) {
  .news-image-container {
    height: 180px;
  }

  .news-content {
    padding: 16px;
    min-height: 120px;
  }

  .news-title {
    font-size: 15px;
  }
}

@media (max-width: 575.98px) {
  .news-image-container {
    height: 200px;
  }

  .news-content {
    padding: 18px;
  }

  .news-title {
    font-size: 16px;
  }
}

/* Grid spacing */
.row.g-4 {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 1.5rem;
}

.row.g-4 > * {
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

/* Training list - media style */
.training-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.training-item {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.training-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.media-link {
  display: flex;
  text-decoration: none;
  color: inherit;
  height: 100%;
  gap: 16px;
  padding: 12px;
}

.media-link:hover {
  text-decoration: none;
  color: inherit;
}

.media-image {
  flex-shrink: 0;
  width: 120px;
  height: 85px;
  border-radius: 8px;
  overflow: hidden;
}

.media-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.training-item:hover .media-image img {
  transform: scale(1.05);
}

.media-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.media-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  color: #2c3e50;
  margin: 0 0 8px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.media-description {
  font-size: 13px;
  color: #6c757d;
  line-height: 1.4;
  margin: 0 0 8px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.media-footer {
  display: flex;
  align-items: center;
  margin-top: auto;
}

.media-date {
  font-size: 12px;
  color: #6c757d;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
}

.media-date i {
  font-size: 14px;
}

/* Responsive for training list */
@media (max-width: 991.98px) {
  .media-image {
    width: 100px;
    height: 100px;
  }

  .media-title {
    font-size: 14px;
  }

  .media-description {
    font-size: 12px;
  }
}

@media (max-width: 767.98px) {
  .training-list {
    gap: 12px;
  }

  .media-link {
    gap: 12px;
    padding: 10px;
  }

  .media-image {
    width: 90px;
    height: 90px;
  }
}
</style>
